import { Quote, Star } from "lucide-react";
import { Reveal, MaskLinesInView } from "@/components/Reveal";
import { TESTIMONIALS } from "@/lib/data";

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="relative bg-blue-deep text-cream py-24 md:py-36 grain overflow-hidden">
      <div className="container-editorial relative z-10">
        <div className="max-w-3xl mb-16">
          <Reveal>
            <p className="eyebrow text-amber-bright mb-6 flex items-center gap-3">
              <span className="w-10 h-px bg-amber-bright" /> 34+ Years, In Their Words
            </p>
          </Reveal>
          <MaskLinesInView
            lines={["The proof isn't the pitch."]}
            className="font-serif font-bold text-4xl md:text-6xl text-cream leading-[1.04]"
          />
          <MaskLinesInView
            lines={["It's the outcomes."]}
            className="font-serif font-bold italic text-4xl md:text-6xl text-amber-bright leading-[1.04] mt-1"
          />
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-cream/10 border border-cream/10">
          {TESTIMONIALS.map((t, i) => (
            <Reveal
              key={i}
              delay={(i % 2) * 0.08}
              className={`group bg-blue-deep p-9 md:p-12 hover:bg-blue transition-colors duration-500 ${
                i === TESTIMONIALS.length - 1 && TESTIMONIALS.length % 2 === 1 ? "md:col-span-2" : ""
              }`}
            >
              <div className="flex items-center justify-between mb-6">
                <Quote size={30} className="text-amber-bright/70" />
                <div className="flex gap-1">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star key={s} size={13} className="text-amber-bright fill-amber-bright" />
                  ))}
                </div>
              </div>
              <p className="font-serif italic text-xl md:text-2xl text-cream leading-snug">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-8 pt-5 border-t border-cream/15">
                <p className="font-serif font-bold text-lg text-cream">{t.name}</p>
                <p className="eyebrow text-[0.58rem] text-amber-bright/80 mt-1">{t.role}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
